(function(){
  if(window.__productTabsUiLoaded)return;
  window.__productTabsUiLoaded=true;
  function init(root){
    if(!root||root.dataset.ready==='1')return;
    root.dataset.ready='1';
    var tabs=Array.prototype.slice.call(root.querySelectorAll('[data-tab]'));
    var panels=Array.prototype.slice.call(root.querySelectorAll('[data-panel]'));
    function activate(tab,focus){
      var id=tab.dataset.tab;
      tabs.forEach(function(item){var selected=item===tab;item.setAttribute('aria-selected',selected?'true':'false');item.tabIndex=selected?0:-1;});
      panels.forEach(function(panel){var selected=panel.dataset.panel===id;panel.hidden=!selected;panel.classList.toggle('is-active',selected);});
      if(focus)tab.focus();
    }
    tabs.forEach(function(tab,index){
      tab.addEventListener('click',function(){activate(tab,false);});
      tab.addEventListener('keydown',function(event){
        var next=index;
        if(event.key==='ArrowRight')next=(index+1)%tabs.length;
        if(event.key==='ArrowLeft')next=(index-1+tabs.length)%tabs.length;
        if(event.key==='Home')next=0;
        if(event.key==='End')next=tabs.length-1;
        if(next!==index){event.preventDefault();activate(tabs[next],true);}
      });
    });
    var box=root.querySelector('[data-ingredients]');
    var toggle=root.querySelector('[data-toggle]');
    if(box&&toggle)toggle.addEventListener('click',function(){var expanded=toggle.getAttribute('aria-expanded')==='true';toggle.setAttribute('aria-expanded',expanded?'false':'true');toggle.textContent=expanded?'Show more':'Show less';box.classList.toggle('is-cut',expanded);});
  }
  function initAll(scope){
    if(scope&&scope.matches&&scope.matches('[data-product-tabs]'))init(scope);
    Array.prototype.forEach.call((scope||document).querySelectorAll('[data-product-tabs]'),init);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){initAll(document);},{once:true});else initAll(document);
  document.addEventListener('shopify:section:load',function(event){initAll(event.target);});
})();
